import {
  GraduateDisciplineCreate,
  GraduateDisciplineEdit,
  GraduateDisciplineList
} from 'pages/graduate_courses/graduate_disciplines';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'graduate_disciplines',
  label: 'Disciplinas',
  list: GraduateDisciplineList,
  edit: GraduateDisciplineEdit,
  create: GraduateDisciplineCreate,
  actions: ['list', 'show', 'edit', 'create'],
  parentName: 'course_creation'
};

export default generateResources(resource);
